'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryController = function () {
  function CategoryController(ImagesDataProvider, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CategoryController);
    this.ImagesDataProvider = ImagesDataProvider;
    this.$state = $state;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
    this.type = 1;
    this.field = 'id';
    this.order_type = 'desc';
    this.col = 0;
    this.colTopDown = 0;
    this.getCategories();
  }

  (0, _createClass3.default)(CategoryController, [{
    key: 'getSortRecors',
    value: function getSortRecors(field, order_type, col, colTopDown) {
      this.field = field;
      this.order_type = order_type;
      this.col = col;
      this.colTopDown = colTopDown;
      this.getCategories();
    }
  }, {
    key: 'getCategories',
    value: function getCategories() {
      var vm = this;
      var data = [];
      data.currentPage = vm.currentPage;
      data.pageLimit = vm.pageLimit;
      data.field = vm.field;
      data.order_type = vm.order_type;
      vm.ImagesDataProvider.getCategory(data).then(function (result) {
        vm.categories = result.data;
        vm.categoriesTotal = result.total;
      });
    }
  }, {
    key: 'removeCategory',
    value: function removeCategory(id) {
      if (confirm("Are you sure to delete!") !== true) {
        return false;
      }
      var vm = this;
      vm.ImagesDataProvider.removeCategory(id).then(function (res) {
        vm.getCategories();
      });
    }
  }]);
  return CategoryController;
}();

// WEBPACK FOOTER //


exports.default = CategoryController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/images/components/category_listing/controller.js
 **/